import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.7778 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 3 21 2 19.7778 2ZM19.7778 19.7778H4.22222V4.22222H19.7778V19.7778ZM17.5556 10.8889H6.44444V13.1111H17.5556V10.8889Z"
  />,
  'CheckBoxIndeterminate'
)
